import * as React from "react";
import TeamCard from "../../../components/cards/teamCard";

const TabMeetTeam = ({ meetTeamData }) => {
  return (
    <>
      <div>
        <div className="py-8 border-b tab-content-head border-b-gray-light">
          <div
            className="text-xlrg-sm leading-[38px] font-light planet:text-white text-generic-text"
            dangerouslySetInnerHTML={{ __html: meetTeamData.title }}
          />
        </div>

        <div className="tab-content-body">
          <div className="grid grid-cols-1 gap-2 py-8 md:grid-cols-2">
            {meetTeamData?.teamMembers?.map((member, index) => {
              return (
                <div
                  key={index}
                  className="flex justify-center col-span-1 p-2 items-top md:col-span-2 lg:col-span-1"
                >
                  <TeamCard
                    sourceUrl={member.sourceFallbackImage}
                    title={member.title}
                    bgImage={""}
                    memberTitle={member.memberTitle}
                    content={member.content}
                    uri={member.uri}
                  />
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};

export default TabMeetTeam;
